// Actions ShopByCollection
export const ActionsShopByCollection = {
	GET_SHOP_BY_COLLECTION: "get_shop_by_collection",
	LOAD_GET_SHOP_BY_COLLECTION: "load_get_shop_by_collection",
	RES_GET_SHOP_BY_COLLECTION: "result_get_shop_by_collection",
	ERR_GET_SHOP_BY_COLLECTION: "error_get_shop_by_collection",
	HYDRATE: "HYDRATE",
};

// Function if FailureShopByCollection
export function failureShopByCollection(error) {

	return {
		type: ActionsShopByCollection.ERR_GET_SHOP_BY_COLLECTION,
		error,
	};

}

// Function if LoadShopByCollection
export function loadShopByCollection(params = {}) {

	return { type: ActionsShopByCollection.GET_SHOP_BY_COLLECTION, ...params };

}

// Function if LoadShopByCollection
export function loadGetShopByCollection(params = {}) {

	return { type: ActionsShopByCollection.LOAD_GET_SHOP_BY_COLLECTION, ...params };

}

// Function if LoadShopByCollectionSuccess
export function loadGetShopByCollectionSuccess(data) {

	return {
		type: ActionsShopByCollection.RES_GET_SHOP_BY_COLLECTION,
		data,
	};

}
